<template>
  <div class="assembly-work-order">
    <div>
      <!-- 面包屑导航 -->
      <div class="white-background list-top-margin" >
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>单位</el-breadcrumb-item>
        </el-breadcrumb>
        <list-top :form="form" @search="search" class="list-top-margin" :goodsShow="false"></list-top>
      </div>
      <div class="white-background">
        <el-row class="list-top-margin">
          <el-col :span="6">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">创建单位</el-button>
            <el-dropdown class="left-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </el-col>
          <!-- <el-col :span="18" class="text-align-right">
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <popover-content :colData="colData" @done="popDone" v-if="popIshow" ></popover-content>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">列配置</el-button>
            </el-popover>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table size="small" :key="uniqueKey" ref="tableData"  row-key="_id" :data="listData" highlight-current-row v-loading="loading" max-height="400px" stripe border element-loading-text="拼命加载中" :header-cell-style="_headerStyle" style="width: 100%;">
          <el-table-column type="selection" width="60" :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="no" label="序号" type="index" width="50" v-if="colData[0].istrue" :fixed="colData[0].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column sortable prop="unitName" label="名称" v-if="colData[1].istrue" :fixed="colData[1].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column  prop="remark" label="备注" v-if="colData[2].istrue" :fixed="colData[2].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column prop="creater" label="创建人" >

          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" ></el-table-column>
          <el-table-column prop="updater" label="修改人" >

          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" ></el-table-column>

          <el-table-column label="操作" width="180" fixed="right" v-if="colData[12].istrue">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip content="删除">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteUser(scope.$index, scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" @close="done" :close-on-click-modal="false">
      <create-dialog v-if="dialogVisible" @done="done" :editRow="editRow" :userData="userData" :modelStatus="modelStatus"></create-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { unitGetList,unitDelete,unitBatchDelete } from '@/api/basicData'
import Pagination from '@/components/Pagination'
import ListTop from './list-top.vue'
import CreateDialog from './create-dialog.vue'
import PopoverContent from '@/components/popover-content.vue'

export default {
  // 注册组件
  components: {
    Pagination,
    ListTop,
    PopoverContent,
    CreateDialog,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getColumnDataList()
    this.getdata(this.form)
  },
  data() {
    return {
      loading: false, //是显示加载
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      form: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken'),
        updateCondition:'0',
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      colData:[],
      popIshow:false,//控制popover显隐
      uniqueKey:new Date().getTime(),
      dialogVisible:false,
      title:'创建单位',
      editRow:{},
      userData:{},
      modelStatus:'',
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    add(){
      this.title = '创建单位'
      this.modelStatus = 'create'
      this.dialogVisible = true
    },
    getUniqueKey(){
      return new Date().getTime()
    },
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          unitName: this.form.unitName,
          remark: this.form.remark,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      unitGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    getColumnDataList(){
     this.colData = [
     { title: "序号", istrue: true, isFixed:false },
	   { title: "单据编号", istrue: true, isFixed:false },
	   { title: "工单数", istrue: true , isFixed:false},
	   { title: "已结束工单", istrue: true , isFixed:false},
	   { title: "计划数", istrue: true , isFixed:false},
	   { title: "完工数", istrue: true, isFixed:false },
	   { title: "生产进度(%)", istrue: true , isFixed:false},
	   { title: "单据进度(%)", istrue: true, isFixed:false },
	   { title: "创建时间", istrue: true, isFixed:false },
	   { title: "更新时间", istrue: true, isFixed:false },
	   { title: "创建人", istrue: true , isFixed:false},
	   { title: "更新人", istrue: true, isFixed:false },
	   { title: "操作", istrue: true,disabled:true },
    ]
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.form)
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.pageparm.pageSize = 10
      this.getdata(this.form)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.title = '编辑单位'
      this.modelStatus = 'edit'
      this.editRow = row
      this.dialogVisible = true
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确认删除单位？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          unitDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.form)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    popDone(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data))
        this.uniqueKey = this.getUniqueKey()
      }
    },
    done(options){
      this.dialogVisible = false
      if(options && options.type == 'save'){
        this.getdata()
      }
      this.editRow = {}
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          unitBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}

.assembly-work-order .el-button+.el-button,
.el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 5px;
}
</style>






// WEBPACK FOOTER //
// src/views/basicData/unit/Unit.vue